import type { BrandTheme } from '../tokens/types'

/**
 * 将 Design Tokens 转换为 CSS Variables 并注入到文档
 */
export function injectCSSVariables(theme: BrandTheme): void {
  if (typeof document === 'undefined') return

  const root = document.documentElement
  const variables = flattenTokens(theme as unknown as Record<string, unknown>, '--checkout')

  for (const [name, value] of Object.entries(variables)) {
    root.style.setProperty(name, value)
  }
}

/**
 * 递归扁平化 tokens 对象为 CSS Variable 格式
 */
function flattenTokens(
  obj: Record<string, unknown>,
  prefix: string
): Record<string, string> {
  const result: Record<string, string> = {}

  for (const [key, value] of Object.entries(obj)) {
    const varName = `${prefix}-${camelToKebab(key)}`

    if (typeof value === 'object' && value !== null) {
      Object.assign(result, flattenTokens(value as Record<string, unknown>, varName))
    } else {
      result[varName] = String(value)
    }
  }

  return result
}

/**
 * camelCase 转 kebab-case
 */
function camelToKebab(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

/**
 * CSS Variable 辅助函数
 */
export const cssVar = {
  color: (name: string) => `var(--checkout-colors-${name})`,
  spacing: (name: string) => `var(--checkout-spacing-${name})`,
  radius: (name: string) => `var(--checkout-border-radius-${name})`,
  shadow: (name: string) => `var(--checkout-shadows-${name})`,
  font: (name: string) => `var(--checkout-typography-${name})`,
  transition: (name: string) => `var(--checkout-transitions-${name})`,
}
